import * as ea from "@mnjsplatform/data/lib/actions/errorActions";
import SubFinanceApi from "../api/subFinanceApi";

export const SUB_FINANCE_EMAILS_LINK_LOADED = "SUB_FINANCE_EMAILS_LINK_LOADED";

export function getSubFinanceEmailsLink(controller, rowKeys) {
    return dispatch => {
        return SubFinanceApi.getDocumentLink(controller, rowKeys)
            .then(data => {
                dispatch({type: SUB_FINANCE_EMAILS_LINK_LOADED, data});
            })
            .catch(error => {
                dispatch(ea.errorRaised(error));
            });
    };
}